import NumberFormat from 'utils/numberFormat';

const useDashboardMetrics = () => {
    const currentYear = new Date().getFullYear();
    const previousMonth = new Date()?.getMonth();
    const currentMonth = new Date()?.getMonth() + 1;
    
    const previousMonthStart = `${currentYear}-${previousMonth.toString().padStart(2,'0')}-01`
    const currentMonthStart = `${currentYear}-${currentMonth.toString().padStart(2,'0')}-01`
    
    const getPercentageDirection = (prevValue, currentValue) => {
        if(Number(prevValue) && Number(currentValue)) {
            return NumberFormat((currentValue / prevValue) * 100);
        } else {
            return 0;
        }
    };
    
    
    return { currentYear, previousMonth, getPercentageDirection, previousMonthStart, currentMonthStart }
}

export default useDashboardMetrics